// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1z_62","nav":"nav-4IXlY","shortcuts":"shortcuts-3uZXI"};